// @ts-nocheck
import styled from 'styled-components';
import {
    spanishViridian500,
    skyBlue200,
    maximumYellow50,
} from '@habitech/shared';


export const Container = styled.div`
    width: 100%;
    padding: 40px 0;
    .icon-edit path{
        fill: ${spanishViridian500};
    }
    td {
        margin: auto;
    }
`;

export const LabelStatus = styled.div`
    padding: 4px 6px 6px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    &.inactivo {
        background-color:${maximumYellow50} ;
    }
    &.activo {  
        background-color: ${skyBlue200};
    }
`;


